import * as React from 'react'

import type { InputLabelProps } from '@material-ui/core/InputLabel'
import {
  type DisplayProps,
  type PaletteProps,
  type SpacingProps,
} from '@material-ui/system'

import { InputLabelStyled } from './styles/InputLabelStyled'

export interface IInputLabelProps
  extends Omit<InputLabelProps, 'color' | 'margin'>,
    SpacingProps,
    DisplayProps,
    PaletteProps {}

// Styled Material InputLabel
export const InputLabel: React.ComponentType<IInputLabelProps> = (props) => (
  <InputLabelStyled {...props} />
)
InputLabel.defaultProps = {
  mb: 0.25,
}

InputLabel.displayName = 'InputLabel'

export { type InputLabelProps, InputLabelStyled }
